import ActionPlugins from "./actions/PluginSetup.js";
const install = molten => {
  ActionPlugins.install(molten);
};
export default {
  install
};